'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { ReactNode } from 'react'

import { useTrackRumAction } from '../../../providers/real-user-monitoring'
import { type HelpContent, TooltipContent } from './_tooltip-content'
type TooltipProps = {
  help: HelpContent
  children: ReactNode
  /**
   * Stable analytics name for tooltip opens. When set, fires `tooltip view on {rumTooltipName}`
   * with dynamic help text in the `tooltipContent` property.
   *
   * Omit to keep the tooltip silent in PostHog — accessible help text is never used as the event name.
   *
   * @example
   * <Tooltip help="Dynamic copy from CMS" rumTooltipName="Order ETA">
   *   <button type="button">Help</button>
   * </Tooltip>
   */
  rumTooltipName?: string
}

/**
 * Internal hover/focus tooltip for help affordances.
 * Not to be used outside of the UI library. For controlled feedback (e.g. copy result),
 * use {@link TooltipFeedback} from the same folder — only imported by CopyButton.
 */
export function Tooltip({ help, children, rumTooltipName }: TooltipProps) {
  const trackRumAction = useTrackRumAction()
  return (
    <TooltipPrimitive.Root
      onOpenChange={(isOpen) => {
        if (isOpen && rumTooltipName) {
          trackRumAction(rumTooltipName, 'tooltip view', {
            tooltipContent: help,
          })
        }
      }}
    >
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipContent help={help} />
    </TooltipPrimitive.Root>
  )
}
